<template>
    <div class="modal" :class="classObject" :id="id" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered" :class="'modal-' + size" role="document">
            <div class="modal-content">
                <div class="modal-header" v-if="hasTitle">
                    <h3 class="modal-title">
                        <slot name="title"></slot>
                    </h3>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" :class="{'p-0' : noPadding }">
                    <slot name="body"></slot>
                </div>
                <div class="modal-footer" v-if="hasFooter">
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            id: {
                type: String,
                required: false,
                default: '',
            },
            size: {
                type: String,
                required: false,
                default: 'md',
            },
            className: {
                type: String,
                required: false,
                default: '',
            }
        },

        computed: {
            classObject() {
                return this.id + ' ' + this.className;
            },

            hasTitle(){
                return !!this.$slots.title
            },

            hasFooter(){
                return !!this.$slots.footer
            },

            noPadding(){
                return !!this.$attrs.hasOwnProperty('noPadding')
            }
        }
    }
</script>
